export const DhlEcommerceWalletedService = Object.freeze({
  ParcelInternationalStandardDdu: '196164',
  ParcelInternationalDirectDdp: '196165',
});
